import { SvgIcon } from './svg-icon';
import { ComponentSvgIconProps, SvgIconProps } from './svg-icon.d';
import { mergeProps } from 'solid-js';

const defaultProps: SvgIconProps = {
    viewBox: '0 0 20 20',
    fill: 'currentColor',
    defaultAriaLabel: 'Basket Icon',
};

export const BasketCviIcon = (componentProps: ComponentSvgIconProps) => {
    const props = mergeProps(defaultProps, componentProps);

    return (
        <SvgIcon {...props}>
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M8.1433 1.48829C8.50471 1.64641 8.66951 2.06757 8.51139 2.42899L6.44915 7.14269H13.5506L11.4883 2.42899C11.3302 2.06757 11.495 1.64641 11.8564 1.48829C12.2178 1.33017 12.639 1.49498 12.7971 1.85639L15.1099 7.14269H17.0431C17.9057 7.14269 18.5716 7.90141 18.4596 8.75675L17.3371 17.3282C17.244 18.0394 16.6379 18.5713 15.9206 18.5713H4.07908C3.36181 18.5713 2.75574 18.0394 2.6626 17.3282L1.54015 8.75675C1.42815 7.90141 2.09399 7.14269 2.95663 7.14269H4.88984L7.2026 1.85639C7.36072 1.49498 7.78188 1.33017 8.1433 1.48829ZM17.0431 8.57126H2.95663L4.07908 17.1427H15.9206L17.0431 8.57126Z"
            />
        </SvgIcon>
    );
};
